var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBackBtn)?_c('button',{staticClass:"back-button",on:{"click":_vm.backTo}},[_c('back-arrow'),_c('span',[_vm._v("Back")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }